module.exports = __webpack_public_path__ + "fonts/Roboto-Light.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Light.woff
// module id = 265
// module chunks = 0